import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SubscriptionListComponent } from './pages';
import { WidgetRouteGaurdService } from 'src/app/core/services/widget-route-gaurd.service';
import { SubscriptionReportComponent } from './pages/subscription-report/subscription-report.component';

const routes: Routes = [
  {
    path:"",
    component: SubscriptionListComponent,
    canActivate: [WidgetRouteGaurdService],
    data: {
      titleheading: "Subscription List",
      title: "Overview",
    },
  },
  {
    path:"mycustomers",
    component: SubscriptionListComponent,
    canActivate: [WidgetRouteGaurdService],
    data: {
      titleheading: "Subscription List",
      title: "Overview",
    },
  },
  {
      path: "membership-report",
      component: SubscriptionReportComponent,
      data: {
          titleheading: "Membership Report",
          title: "Membership Report",
      }
  },
  {
    path: "checkin-report",
    component: SubscriptionReportComponent,
    data: {
        titleheading: "Check In Report",
        title: "Check In Report",
    }
}
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubscriptionRoutingModule { }
